import React from 'react';
import {
  ImageTextSection,
  CustomRow,
  TextLayout,
  Heading,
  Description1,
  ImageHolder,
  HighlighText,
} from './imagetext1.style';
import { Container, Col } from '@bootstrap-styled/v4';
import GatsImg from 'gatsby-image';
import { useStaticQuery, graphql } from 'gatsby';

const ImageText1 = () => {
  const JSONData = useStaticQuery(graphql`
    query {
      pagedataJson {
        ImageText1 {
          Heading
          SectionHeading
          Description1
          Description2
          Description3
          ContactUsBtn
          Img {
            childImageSharp {
              fluid(quality: 70) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  `);
  return (
    <ImageTextSection id="imagetext1Container">
      <Container>
        <CustomRow>
          <Col md={12} lg={8}>
            <TextLayout>
              <Heading>doboktatás</Heading>
              <Description1>
                Az oktatás
                <HighlighText> gyerekeknek és felnőtteknek, kezdőtől haladó szintig</HighlighText>,
                egyénileg, személyre szabottan történik Budapesten, a 11. kerületben.
              </Description1>
              <Description1>
                A tanítás során nagy hangsúlyt fektetünk a biztos alapok, technikák helyes
                elsajátítására, miközben folyamatosan szem előtt tartom az egyéni célodat.
                Mindenkinek a saját tempójában haladunk, miközben mindvégig zene központú tanulásra,
                játékra koncentrálunk.
              </Description1>
            </TextLayout>
          </Col>
          <Col md={12} lg={4}>
            <ImageHolder>
              <GatsImg fluid={JSONData.pagedataJson.ImageText1.Img.childImageSharp.fluid} alt="" />
            </ImageHolder>
          </Col>
        </CustomRow>
      </Container>
    </ImageTextSection>
  );
};

export default ImageText1;
